/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Webhook_Token_PendingInputs */

const cs_webhook_token_pending = /** @type {(inputs: Webhook_Token_PendingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Token se vygeneruje po uložení workflow.`)
};

const en_webhook_token_pending = /** @type {(inputs: Webhook_Token_PendingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Save the workflow to generate a token.`)
};

/**
* | output |
* | --- |
* | "Save the workflow to generate a token." |
*
* @param {Webhook_Token_PendingInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const webhook_token_pending = /** @type {((inputs?: Webhook_Token_PendingInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Webhook_Token_PendingInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_webhook_token_pending(inputs)
	return cs_webhook_token_pending(inputs)
});